import axios from "axios";
import { appConifg } from "../config/default";
//import  axiosClientWrapper  from './axiosClientWrapper'

const HARD_CODE_TOKEN =
  "GLHppyIaWuHJmmiVacGhfbG8FR6IjUQpmZJfbxt0O4KEwTOpeZaHKk7lcyn4-eT0mLF61T1ecdYWlVQVWlJgBWsNvHmpaGGiCF52xyZClXLZ0jzzTlHWvQ3nyfXgBh8AQ2mGvHIHorzkTDaDkmV7Tg..";

const _ADDRESS_SUGGESTIONS_URLEN = appConifg.Address.SuggestionsUrlEN;
const _ADDRESS_SUGGESTIONS_URLAR = appConifg.Address.SuggestionsUrlAR;
const _FIND_ADDRESS_URLEN = appConifg.Address.FindAddressUrlEN;
const _FIND_ADDRESS_URLAR = appConifg.Address.FindAddressUrlAR;
const _PARCEL_SERVICE_URL = appConifg.Address.ParcelServiceUrl;
const _STREET_SERVICE_URL = appConifg.Address.StreetsServiceUrl;
const _POSTAL_SERVICE_URL = appConifg.Address.PostalServiceUrl;
const _AREA_SERVICE_URL = appConifg.Address.AreaServiceUrl;
const _TOKEN_URL = appConifg.Map.TokenUrl;
const _PORTAL_USER_NAME = appConifg.Map.PortalUserName;
const _PORTAL_PASSWORD = appConifg.Map.PortalPassword;
const _APP_REFERER = appConifg.Map.AppReferer;
const _PROXY_URL = appConifg.ProxyUrl;
const _ADDRESS_API_URL = appConifg.Address.AddressApiUrl;
const _GEOMETRY_SERVICE_URL = appConifg.Address.GeometryServiceUrl;

// const hObje_urlEncded = {
//     headers : {
//         "Content-Type" : "application/x-www-form-urlencoded",
//         "Access-Control-Allow-Origin" : "*"
//     }
//   }

// const _headerObj =  {
//     "Content-Type" : "application/x-www-form-urlencoded",
//     "Access-Control-Allow-Origin" : "*"
// }

const API_CLIENT = axios.create({
  //headers : _headerObj
});

const getAuthorizatonHeader = (token) => {
  return {
    Authorization: "bearer " + token,
  };
};

const getReqUrlEncodeParms = (params) =>
  Object.keys(params)
    .map((key) => `${key}=${encodeURIComponent(params[key])}`)
    .join("&");

export const getParcelDetails = (parcelid, token) => {
  let source = axios.CancelToken.source();
  var whereClause = `PARCELID='${parcelid}'`;
  var params = { where: whereClause, f: "json" };
  const req_data = Object.keys(params)
    .map((key) => `${key}=${encodeURIComponent(params[key])}`)
    .join("&");
  let promise = API_CLIENT.post(
    _PROXY_URL + "?" + _PARCEL_SERVICE_URL + "/query",
    req_data,
    { CancelToken: source.token }
  );
  return [promise, source];
};

export const getStreetDetails = (street_number, token) => {
  let source = axios.CancelToken.source();
  var whereClause = `StreetNumber ='${street_number}'`;
  var params = { where: whereClause, f: "json" };
  const req_data = Object.keys(params)
    .map((key) => `${key}=${encodeURIComponent(params[key])}`)
    .join("&");
  let promise = API_CLIENT.post(
    _PROXY_URL + "?" + _STREET_SERVICE_URL + "/query",
    req_data,
    { CancelToken: source.token }
  );
  return [promise, source];
};

export const getPostalAreaDetails = (emPostCode, token) => {
  let source = axios.CancelToken.source();
  var whereClause = `EmPostCode  ='${emPostCode}'`;
  var params = { where: whereClause, f: "json", outFields: "*" };
  const req_data = Object.keys(params)
    .map((key) => `${key}=${encodeURIComponent(params[key])}`)
    .join("&");
  let promise = API_CLIENT.post(
    _PROXY_URL + "?" + _POSTAL_SERVICE_URL + "/query",
    req_data,
    { CancelToken: source.token }
  );
  return [promise, source];
};

export const getAreaDetails = (areaId, token) => {
  let source = axios.CancelToken.source();
  var whereClause = `AreaID   ='${areaId}'`;
  var params = { where: whereClause, f: "json", outFields: "*" };
  const req_data = Object.keys(params)
    .map((key) => `${key}=${encodeURIComponent(params[key])}`)
    .join("&");
  let promise = API_CLIENT.post(
    _PROXY_URL + "?" + _AREA_SERVICE_URL + "/query",
    req_data,
    { CancelToken: source.token }
  );
  return [promise, source];
};

export const generatePortalToken = () => {
  let source = axios.CancelToken.source();

  const tokenUrl = _TOKEN_URL;
  var userName = _PORTAL_USER_NAME;
  var password = _PORTAL_PASSWORD;
  var referer = _APP_REFERER;
  var params = {
    f: "json",
    username: userName,
    password: password,
    referer: referer,
  };
  const req_data = Object.keys(params)
    .map((key) => `${key}=${encodeURIComponent(params[key])}`)
    .join("&");

  let promise = API_CLIENT.post(tokenUrl, req_data, {
    CancelToken: source.token,
  });
  return [promise, source];
};

export const getPointAddressSuggestions = (searchTxt, language) => {
  let source = axios.CancelToken.source();
  var adress_req_data = {
    text: searchTxt,
    category: "Point Address",
    f: "json",
    maxSuggestions: 10,
  };
  const req_data = getReqUrlEncodeParms(adress_req_data);
  let promise = API_CLIENT.post(
    _PROXY_URL +
      "?" +
      (language == "en"
        ? _ADDRESS_SUGGESTIONS_URLEN
        : _ADDRESS_SUGGESTIONS_URLAR),
    req_data,
    { CancelToken: source.token }
  );
  return [promise, source];
};

export const getStreetAddressSuggestions = (searchTxt, language) => {
  let source = axios.CancelToken.source();
  var adress_req_data = { text: searchTxt, category: "Street Name", f: "json" };
  //var adress_req_data = {"text" : searchTxt ,  f :"json"}
  const req_data = getReqUrlEncodeParms(adress_req_data);
  let promise = API_CLIENT.post(
    _PROXY_URL +
      "?" +
      (language == "en"
        ? _ADDRESS_SUGGESTIONS_URLEN
        : _ADDRESS_SUGGESTIONS_URLAR),
    req_data,
    { CancelToken: source.token }
  );
  return [promise, source];
};

export const getAreaAddressSuggestions = (searchTxt, language) => {
  let source = axios.CancelToken.source();
  var adress_req_data = {
    text: searchTxt,
    category: "Populated Place",
    f: "json",
  };
  const req_data = getReqUrlEncodeParms(adress_req_data);
  let promise = API_CLIENT.post(
    _PROXY_URL +
      "?" +
      (language == "en"
        ? _ADDRESS_SUGGESTIONS_URLEN
        : _ADDRESS_SUGGESTIONS_URLAR),
    req_data,
    { CancelToken: source.token }
  );
  return [promise, source];
};

export const getPostalAddressSuggestions = (searchTxt, language) => {
  let source = axios.CancelToken.source();
  var adress_req_data = { text: searchTxt, category: "Postal", f: "json" };
  const req_data = getReqUrlEncodeParms(adress_req_data);
  let promise = API_CLIENT.post(
    _PROXY_URL +
      "?" +
      (language == "en"
        ? _ADDRESS_SUGGESTIONS_URLEN
        : _ADDRESS_SUGGESTIONS_URLAR),
    req_data,
    { CancelToken: source.token }
  );
  return [promise, source];
};

export const getAddressCandidateByMkey = (magicKey, language) => {
  let source = axios.CancelToken.source();
  var adress_req_data = {
    magicKey: magicKey,
    f: "json",
    outFields: "*",
  };
  const req_data = getReqUrlEncodeParms(adress_req_data);
  let promise = API_CLIENT.post(
    _PROXY_URL +
      "?" +
      (language == "en" ? _FIND_ADDRESS_URLEN : _FIND_ADDRESS_URLAR),
    req_data,
    { CancelToken: source.token }
  );
  return [promise, source];
};

export const getAddressCandidateByText = (text, language) => {
  let source = axios.CancelToken.source();
  var adress_req_data = {
    Address: text,
    f: "json",
    outFields: "*",
  };
  const req_data = getReqUrlEncodeParms(adress_req_data);
  let promise = API_CLIENT.post(
    _PROXY_URL +
      "?" +
      (language == "en" ? _FIND_ADDRESS_URLEN : _FIND_ADDRESS_URLAR),
    req_data,
    { CancelToken: source.token }
  );
  return [promise, source];
};

export const getAddressIssueStatuTypes = (token) => {
  let source = axios.CancelToken.source();
  var endPoint = _ADDRESS_API_URL + "/AddressingIssuesStatus/getall";

  let promise = API_CLIENT.get(endPoint, {
    CancelToken: source.token,
    headers: getAuthorizatonHeader(token),
  });
  return [promise, source];
};

export const getAddressIssueTypes = (token) => {
  let source = axios.CancelToken.source();
  var endPoint = _ADDRESS_API_URL + "/AddressingIssuesType/getall";

  let promise = API_CLIENT.get(endPoint, {
    CancelToken: source.token,
    headers: getAuthorizatonHeader(token),
  });
  return [promise, source];
};

export const getAddressByHashkey = (key, token) => {
  let source = axios.CancelToken.source();
  var endPoint =
    _ADDRESS_API_URL +
    "/LocatorDetails/GetLocatorDetailsByAddressPointId/" +
    key;
  let promise = API_CLIENT.get(endPoint, {
    CancelToken: source.token,
    headers: getAuthorizatonHeader(token),
  });
  return [promise, source];
};

export const getAllAddressIssues = (token) => {
  let source = axios.CancelToken.source();
  var endPoint = _ADDRESS_API_URL + "/AddressingIssues/getall";

  let promise = API_CLIENT.get(endPoint, {
    CancelToken: source.token,
    headers: getAuthorizatonHeader(token),
  });
  return [promise, source];
};

//this is to get AddressPoint Details from the AddressingAPI backend
export const getAddressDetials = (pointId, streetId, areaId, token) => {
  let source = axios.CancelToken.source();

  var endPoint = _ADDRESS_API_URL + "/LocatorDetails/GetLocatorDetails";
  var reqData = {
    PointId: pointId,
    AreaId: areaId,
    StreetNumber: streetId,
  };
  let promise = API_CLIENT.post(endPoint, reqData, {
    CancelToken: source.token,
    headers: getAuthorizatonHeader(token),
  });
  return [promise, source];
};

export const getAddressDetailsFromParcelId = (parcelid, token) => {
  let source = axios.CancelToken.source();
  var endPoint =
    _ADDRESS_API_URL +
    "/LocatorDetails/GetLocatorDetailsByParcelId/" +
    parcelid;
  let promise = API_CLIENT.get(endPoint, {
    CancelToken: source.token,
    headers: getAuthorizatonHeader(token),
  });
  return [promise, source];
};

//Using Geomtetry Service
export const getLabelPointOfPolygon = (polygon) => {
  let source = axios.CancelToken.source();
  var params = {
    "polygons ": [{ rings: polygon.rings }],
    f: "json",
    sr: polygon.spatialReference.wkid,
  };
  const req_data = Object.keys(params)
    .map((key) => `${key}=${encodeURIComponent(params[key])}`)
    .join("&");
  let promise = API_CLIENT.post(
    _PROXY_URL + "?" + _GEOMETRY_SERVICE_URL + "/labelPoints",
    params,
    { CancelToken: source.token }
  );
  return [promise, source];
};

export const getAddressIssuesPaginated = (parmsObj, token) => {
  console.log("parmsObj", JSON.stringify(parmsObj));
  var endPoint = _ADDRESS_API_URL + "/AddressingIssues/GetPaginated";

  var OrderBy =
    Object.values(parmsObj.sortOrder) < 1
      ? null
      : parmsObj.sortOrder.name + " " + parmsObj.sortOrder.direction;
  var reqData = {
    PageNo: parmsObj.page ? parmsObj.page + 1 : 1,
    PageSize: parmsObj.rowsPerPage ? parmsObj.rowsPerPage : 10,
    OrderBy: OrderBy,
    ReportUserNames: null,
    MobileNUmbers: null,
    AssignedUserNames: null,
    IssueStauses: parmsObj.IssueStauses.length > 0 ? parmsObj.IssueStauses : [],
    IssueTypes: parmsObj.IssueTypes.length > 0 ? parmsObj.IssueTypes : [],
  };

  let source = axios.CancelToken.source();
  let promise = API_CLIENT.post(endPoint, reqData, {
    CancelToken: source.token,
    headers: getAuthorizatonHeader(token),
  });
  return [promise, source];
};

export const getAddressIssueAttachment = (issueId, token) => {
  let source = axios.CancelToken.source();

  var endPoint =
    _ADDRESS_API_URL +
    "/AddressingIssuesAttachments/GetAttachmentsByIssueId/" +
    issueId;
  let promise = API_CLIENT.get(endPoint, {
    CancelToken: source.token,
    headers: getAuthorizatonHeader(token),
  });
  return [promise, source];
};

export const respondToAddressIssue = (
  issueId,
  responderName,
  comment,
  token
) => {
  var reqData = {
    IssueId: issueId,
    ResponderUserName: responderName,
    ResponderComment: comment,
  };

  let source = axios.CancelToken.source();
  var endPoint = _ADDRESS_API_URL + "/AddressingIssues/RespondToIssue";
  let promise = API_CLIENT.post(endPoint, reqData, {
    CancelToken: source.token,
    headers: getAuthorizatonHeader(token),
  });
  return [promise, source];
};
